var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-404"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"m-0 text-danger"},[_vm._v("404 Not Found")]),_c('p',{staticClass:"m-0"},[_vm._v(" This page "),_c('code',[_vm._v(_vm._s(_vm.$route.fullPath))]),_vm._v(" does not exist ")]),_c('router-link',{attrs:{"to":"/"}},[_vm._v(" Go to Home ")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }